import { render, staticRenderFns } from "./TransactionBreakdown.vue?vue&type=template&id=0fbe91d7&scoped=true"
import script from "./TransactionBreakdown.vue?vue&type=script&lang=js"
export * from "./TransactionBreakdown.vue?vue&type=script&lang=js"
import style0 from "./TransactionBreakdown.vue?vue&type=style&index=0&id=0fbe91d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbe91d7",
  null
  
)

export default component.exports